<template>
        <v-row no-gutters class="align-self-center">
            <v-col class="overflow-hidden">
                <loading-overlay :loading="loading"></loading-overlay>
                <v-row class="justify-end pa-4 absolute-top align-center" no-gutters v-if="showLoginForm">
                    <v-col
                        class="text-right"
                        :class="{ 'mr-12': showLoginForm && !$vuetify.breakpoint.mdAndUp }"
                      >
                        <p>
                            <span
                                class="body-2 grey--text text--darken-1 d-none d-sm-inline-flex flex-wrap"
                                >Don’t have an account?</span
                            >
                            <router-link :to="{ name: 'sign-up' }">
                                <v-btn
                                    href="#"
                                    class="px-sm-12 ml-4"
                                    color="primary"
                                    outlined
                                    medium
                                >
                                    Sign up
                                </v-btn>
                            </router-link>
                        </p>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col
                        class="announcements pa-3 pa-md-6 pa-lg-12 col-12" lg="6"
                        :class="{ 'd-none': showLoginForm && !$vuetify.breakpoint.mdAndUp }"
                    >
                        <!-- <div class="my-5 text-center">
                            <h1 class="white--text font-weight-bold mb-1">You Asked, We Listened</h1>
                            <h3 class="white--text">We are now live in over 40 Countries!</h3>
                        </div>

                        <div class="information">
                            <h3 class="white--text">What does this mean for you?</h3>

                            <div class="ml-5">
                                <div class="d-flex">
                                    <h4 class="amber--text mr-2">Great Rates</h4>
                                    <v-img src="/images/dollar-bills.png" height="23" max-width="30" />
                                </div>
                                <p class="title white--text mb-12">
                                    Our users in the diaspora can now send Naira to any bank account in Nigeria at the best rates available. Seriously.
                                </p>
                            </div>

                            <div class="ml-5 mt-n8 mt-sm-0">
                                <div class="d-flex">
                                    <h4 class="amber--text mr-2">Convert Instantly</h4>
                                    <v-img src="/images/explosion.png" height="30" max-width="30" />
                                </div>
                                <p class="title white--text mb-5">
                                    You can now swap your Naira for USD cash from any of the 40+ countries we operate in across the world, directly into your Nigerian domiciliary account, today. It’s that easy.
                                </p>
                            </div> -->

                            <div class="text-center d-sm-flex justify-sm-center mt-5" v-if="$vuetify.breakpoint.smAndDown">
                                <div>
                                    <v-btn
                                        class="px-14 text--white text-none subtitle-1"
                                        color="primary"
                                        dark
                                        @click="showLoginForm = !showLoginForm"
                                        depressed
                                    >
                                        Log in
                                    </v-btn>
                                </div>
                                <div class="mt-3 mt-sm-0 ml-sm-5">
                                    <v-btn
                                        class="px-12 text-none primary--text subtitle-1"
                                        color="white"
                                        dark
                                        href="/sign-up"
                                        depressed
                                    >
                                        Sign Up
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-col>
                    <v-col :class="{ 'd-none d-lg-block': !showLoginForm }">
                        <v-btn
                            icon
                            dark
                            absolute
                            top
                            v-if="$vuetify.breakpoint.smAndDown"
                            right
                            color="primary"
                            @click="showLoginForm = !showLoginForm"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <div class="form mx-auto py-16 my-12">
                            <div class="my-5 text-center">
                                <v-img
                                    alt="logo"
                                    src="/svg/logo.svg"
                                    class="align-self-start mb-1 mx-auto"
                                    width="150"
                                    contain
                                ></v-img>
                            </div>
                            <h1 class="display-1 font-weight-bold primary--text mb-4">
                                Sign in
                            </h1>
                            <h2 class="subtitle-1 mb-8">
                                Log into your Kaoshi account
                            </h2>
                            <v-form
                                class="text-center"
                                @keyup.native.enter="login"
                            >
                                <v-text-field
                                    autofocus
                                    aria-required
                                    required
                                    name="email"
                                    v-validate="'required|email'"
                                    validate-on-blur
                                    :error-messages="errors.first('email')"
                                    type="email"
                                    label="Email"
                                    append-icon="mdi-email-outline"
                                    background-color="#fcfcfc"
                                    v-model="loginCredentials.username"
                                    outlined
                                    :class="{ 'input-group--dirty': isAutoFill }"
                                    ref="email"
                                >
                                </v-text-field>

                                <v-text-field
                                    aria-required
                                    required
                                    v-model="loginCredentials.password"
                                    :append-icon="
                                        passwordVisible ? 'mdi-eye-off' : 'mdi-eye'
                                    "
                                    :rules="[rules.required]"
                                    :type="passwordVisible ? 'text' : 'password'"
                                    name="Password"
                                    label="Password"
                                    v-validate="'required|verify-password'"
                                    validate-on-blur
                                    :error-messages="errors.first('Password')"
                                    @click:append="passwordVisible = !passwordVisible"
                                    outlined
                                    background-color="#fcfcfc"
                                    :class="{ 'input-group--dirty': isAutoFill }"
                                    ref="password"

                                ></v-text-field>

                                <v-row no-gutters class="align-center">
                                    <v-col class="pb-6">
                                        <p class="text-left caption primary--text mb-0">
                                            <router-link :to="{ name: 'password-reset' }">
                                                Forgot Password
                                            </router-link>
                                        </p>
                                    </v-col>
                                    <v-col class="pb-6">
                                        <p class="text-right caption primary--text mb-0">
                                            <router-link to="/sign-up">
                                                Don't have an account?
                                                <br />
                                                Sign Up
                                            </router-link>
                                        </p>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-btn
                                            class="px-12 text--white"
                                            color="primary"
                                            block
                                            dark
                                            depressed
                                            x-large
                                            @click.prevent="login"
                                        >
                                            Log in
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-col>

            <v-dialog v-model="showTfaDialog">
                <tfa
                    style="background-color: #fff;"
                    v-if="loginData && loginData.user && loginData.token"
                    :userId="loginData.user.id"
                    :token="loginData.token"
                    @success="onTfaSuccess"
                    @error="onTfaError"
                    @loading="loading = true"
                    @loaded="loading = false"
                    :show.sync="showTfaDialog"
                />
            </v-dialog>

            <userGenderDialog ref="userGenderDialog" />
        </v-row>
</template>

<script>
import tfa from './components/tfa.vue';
import userGenderDialog from './user-gender-dialog.vue';

export default {
    components: {
      tfa,
      userGenderDialog,
    },
    data: function() {
        return {
            year: Vue.moment().year(),
            passwordVisible: false,
            rules: {
                required: (value) => !!value || 'This field is required.'
            },
            loginCredentials: {
                username: this.$route.query.email || '',
                password: ''
            },
            loading: false,
            isAutoFill: false,
            loginData: null,
            showTfaDialog: false,
            showLoginForm: this.$vuetify.breakpoint.mdAndDown,
        };
    },
    methods: getMethods(),
    mounted: mounted
};

function mounted() {
    // Sometimes logout doesn't turn the loading overlay off; let's force it off here.
    this.loading = false;
    window.dispatchEvent(new Event('positionBottomButton'));
    this.$refs.email.$refs.input.addEventListener('animationstart', this.handleAutofill)
    this.$refs.password.$refs.input.addEventListener('animationstart', this.handleAutofill)

    this.processMessageFromQuery();
}

function getMethods() {
    return {
        login,
        redirectAfterLogin,
        handleAutofill,
        onAutoFillStart,
        onAutoFillCancel,
        onTfaSuccess,
        onTfaError,
        processMessageFromQuery,
    };

    function login() {
        const vm = this;

        vm.$validator.validateAll().then(submitIfValid);
        function submitIfValid(formIsValid){
            if(formIsValid){
                vm.loading = true;
                Vue.backendApi()
                    .login(vm.loginCredentials)
                    .then(loginSuccess, loginError);
            }
        }

        async function loginSuccess(response) {
            vm.loading = false;
            let user = response.data.user;
            let token = response.data.token;

            if(!token.token_type) {
                vm.$swal({
                    type: 'error',
                    title: 'Sign in error',
                    text: 'Missing token type',
                });
                return false;
            }

            if(!token.access_token) {
                vm.$swal({
                    type: 'error',
                    title: 'Sign in error',
                    text: 'Missing access token',
                });
                return false;
            }

            if (parseInt(user.tfa_required_for_login) === 1) {
                Vue.set(vm, 'loginData', {
                    user,
                    token,
                });
                vm.showTfaDialog = true;
                return true;
            } else {
                if (!user.gender) {
                    await vm.$refs.userGenderDialog.show(user.id, token);
                }

                vm.$store.commit('storeUser', user);
                vm.$store.commit('storeAuthToken', token);
                vm.$store.commit('setCurrentLoginTime');
                vm.$store.commit('setIsShowP2PFirst', true);

                vm.redirectAfterLogin(user);
            }
        }

        function loginError(error) {
            let unverifiedRe = new RegExp('is not verified');

            vm.loading = false;
            if (error.match(unverifiedRe)) {
                vm.$swal({
                    type: 'error',
                    title: 'Please Verify Your Account',
                    text: 'Your account must be verified before you can use Kaoshi. Please check your e-mail for instructions.',
                });
                vm.$router.push({
                    name: 'user-confirmation-link-resend',
                });

                return;
            } else {
                vm.$swal({
                    type: 'error',
                    title: 'Sign in error',
                    text: error
                });
            }
        }
    }

        function redirectAfterLogin(user) {
            const vm = this;
            const { redirectTo } = vm.$route.query;
            if (redirectTo) {
                vm.$router.push(redirectTo);
                return true;
            }

            if (!user.options['send-or-receive-money']) {
                vm.$router.push({
                    name: 'send-or-receive-money',
                });
                return true;
            }

            if (user.unpublishedOrdersCount > 0) {
                vm.$router.push('/user/settings#delivery-method');
                return true;
            }

            const routeName = vm.$_user.can_post_offers ? 'offers-create' : 'offers-list';

            return vm.$router.push({
                name: routeName,
            });
        }

    function handleAutofill(e) {
        const vm = this;

        if (e.animationName === 'onAutoFillStart') {
            vm.onAutoFillStart();
        } else {
            vm.onAutoFillCancel();
        }
    }

    function onAutoFillStart() {
        this.isAutoFill = true;
    }
     function onAutoFillCancel() {
        this.isAutoFill = false;
    }

    async function onTfaSuccess(response) {
        const { tokenModel } = response.data;
        const token = this.loginData.token;
        token.scope = tokenModel.scopes;

        const { user } = this.loginData;
        if (user && !user.gender) {
            await this.$refs.userGenderDialog.show(user.id, token);
        }

        this.loading = false;
        this.$store.commit('storeUser', this.loginData.user);
        this.$store.commit('storeAuthToken', token);
        this.$store.commit('setCurrentLoginTime');
        this.$store.commit('setIsShowP2PFirst', true);
        this.redirectAfterLogin(this.loginData.user);
    }

    function onTfaError(error) {
        this.loading = false;
        this.$swal({
            type: 'error',
            title: 'Sign in error',
            text: error
        });
    }

    function processMessageFromQuery() {
        const{ message, email, error } = this.$route.query;
        if (!message) {
          return false;
        }

        if (!error) {
            this.$swal({
                type: 'success',
                title: message,
                text: 'Click OK to continue',
            });
        } else {
            this.$swal({
                type: 'error',
                title: 'Error verifying confirmation token',
                text: message,
                preConfirm: () => this.$router.push({
                    name: 'user-confirmation-link-resend',
                    query: {
                        email,
                    },
                }),
            });
        }
    }
}

</script>
<style scoped>
.slogan {
    color:#1a224e;
    font-size: .625rem!important;
    font-weight: 400;
    letter-spacing: .1666666667em!important;
    line-height: 1rem;
    font-family: Roboto,sans-serif!important;
    margin-top: .625rem;
    margin-left: 1rem;
    margin-bottom: 0;
    white-space: nowrap;
}

.form {
    text-align: center;
    max-width: 350px;
}

@media screen and (min-width: 600px) {
    .absolute-top {
        position: fixed;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1300px;
        width: 90%;
    }
}
</style>

<style scoped>
.announcements {
    background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.6)), url('/images/login-bg-3.jpg');
    background-size: cover;
    background-position: center center;
    height: 100vh;
    position: relative;
}

.announcements::before {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: #010101;
}

.announcements h1 {
    font-size: 2.2em;
}

.announcements h3 {
    font-size: 1.8em;
}

.announcements .information {
    position: absolute;
    bottom: 15px;
}

.announcements .information h3 {
    font-size: 1.5rem;
}

.announcements .information div h4 {
    font-size: 1.2rem;
}

.announcements .information p {
    line-height: 2.2rem;
}

@media screen and (min-width: 960px) and (max-width: 1250px) {
    .announcements {
        height: 50vh;
    }
}
</style>

<style lang="scss">
@keyframes onAutoFillStart {
    from {/**/}
    to {/**/}
}

@keyframes onAutoFillCancel {
    from {/**/}
    to {/**/}
}

.v-text-field input {
    &:-webkit-autofill {
        /* Expose a hook for JavaScript when auto fill is shown. */
        /* JavaScript can capture 'animationstart' events */
        animation-name: onAutoFillStart;

        transition: background-color 50000s ease-in-out 0s;
    }

    &:not(:-webkit-autofill) {
        /* Expose a hook for JS onAutoFillCancel */
        /* JavaScript can capture 'animationstart' events */
        animation-name: onAutoFillCancel;
    }
}
</style>
